import React from 'react'
import List from './List'
import { useDistributionDetailsById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const distribution = useDistributionDetailsById(id)
  return (
    <List distribution={distribution} />
  )
}

export default Body
